"use client";

import React from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HomeCareCoreValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const features = ["最高可申請 40,000 元補助", "專業聽力師到府評估服務", "簡化行政流程 協助代辦", "透明化進度 快速核發"];
  return <section data-section-id="72208" id="助聽器補助申請" className="bg-background relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_var(--color-primary)_0%,_transparent_70%)] opacity-10"></div>

      <div ref={ref} className={`container mx-auto flex flex-col items-center px-4 text-center transition-all duration-1000 md:px-6 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <Badge variant="secondary" className="mb-8 rounded-sm border-none bg-accent px-4 py-1.5 text-sm font-medium text-primary hover:bg-accent/80">
          政府補助 • 專業諮詢 • 流程簡化
        </Badge>

        <h1 className="mb-6 max-w-4xl text-4xl font-bold leading-tight tracking-tight text-foreground md:text-6xl md:leading-tight">
          助聽器政府補助申請 <span className="text-primary">專業代辦</span>
          <br className="hidden md:block" /> 減輕負擔 重拾清晰聆聽
        </h1>

        <p className="mb-12 max-w-3xl text-lg leading-relaxed text-muted-foreground md:text-xl">
          瑞聲助聽器到府服務團隊致力於協助長輩與家屬申請政府助聽器補助。從資格評估到文件代辦，我們提供一站式專業服務，讓您省時省力，協助您以最優惠的價格獲得專業聽力照護。
        </p>

        <div className="mb-12 grid w-full max-w-3xl grid-cols-1 gap-x-12 gap-y-6 text-left md:grid-cols-2">
          {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3">
              <CircleCheck className="h-6 w-6 shrink-0 text-primary" />
              <span className="text-lg font-medium text-foreground">
                {feature}
              </span>
            </div>)}
        </div>

        <div className="flex w-full flex-col gap-4 sm:w-auto sm:flex-row">
          <Button asChild size="lg" className="h-14 rounded-sm bg-primary px-8 text-lg text-primary-foreground shadow-md shadow-primary/20 hover:bg-primary/90">
            <Link to="https://interton.com.tw/助聽器補助/">
              查詢補助資格 <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-14 rounded-sm border-primary px-8 text-lg text-primary hover:bg-primary/5">
            <Link to="https://interton.com.tw/wp-content/uploads/2026/03/助聽器補助申請資格_浮水印.png" download>下載申請指南</Link>
          </Button>
        </div>
      </div>
    </section>;
}